export async function createSurveyConfig() {
  return {
    pages: [
      {
        name: "contactDetails",
        title: "Pā Mai - Send Us A Message!",
        elements: [
          {
            type: "text",
            name: "name",
            title: "Name",
            placeHolder: "Ingoa",
            isRequired: true,
          },
          {
            title: "Email",
            type: "text",
            name: "email",
            placeHolder: "Īmeera",
            validators: [
              {
                type: "email",
              },
            ],
            startWithNewLine: true,
            isRequired: true,
          },
          {
            type: "comment",
            name: "message",
            title: "Message",
            placeHolder: "Kōrero",
            startWithNewLine: true,
            isRequired: true,
          },
        ],
      },
    ],
  };
}
